import { Action } from 'redux';
import * as actions from './actions';
import { Release } from '@common/types/release/release';
import { SimpleRelease } from '@common/types/release/simple-release';
import { ReleaseListSummary } from '@common/types/release/release-list-summary';

import { ErrorAction } from '../common/error-action';
import { LoadingAction } from '../common/loading-action';
import { ReleaseListKey } from '@common/types/release/release-list-key';
import SimpleArtist from '../../../../../common/types/artist/simple-artist';
import { ReleaseStore } from '@common/types/release/release-store';
import { ReleaseStatus } from '@common/types/release/relase-status';
import { ArtistSearchResult } from '@services/artist/types/artist-search-result';

export class EditRelease implements Action {
  readonly type = actions.EDIT_RELEASE;

  constructor(public release?: Partial<Release>) {}
}

export class CleanRelease implements Action {
  readonly type = actions.CLEAN_RELEASE;

  constructor(public artistId?: string, public artistName?: string) {}
}

export class StartRelease implements Action {
  readonly type = actions.START_RELEASE;
}

export class UpdateField<T extends keyof Release> implements Action {
  readonly type = actions.UPDATE_FIELD;

  constructor(
    public field: T,
    public value?: Release[T],
    public disableAutoSave?: boolean,
    public isInput?: boolean
  ) {}
}

export class ChangeReleaseInputField<T extends keyof Release>
  implements Action
{
  readonly type = actions.RELEASE_ON_CHANGE_INPUT_FIELD;

  constructor(public field: T, public value?: Release[T]) {}
}

export class CreateRelease implements LoadingAction {
  readonly type = actions.CREATE_RELEASE;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public release: Partial<SimpleRelease>) {}
}

export class CreateReleaseSuccess implements LoadingAction {
  readonly type = actions.CREATE_RELEASE_SUCCESS;
  readonly isLoading = false;

  constructor(public release: Partial<SimpleRelease>) {}
}

export class CreateReleaseError implements ErrorAction {
  readonly type = actions.CREATE_RELEASE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class PublishRelease implements LoadingAction {
  readonly type = actions.PUBLISH_RELEASE;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public artistId: string,
    public releaseId: string,
    public release: Partial<Release>
  ) {}
}

export class PublishReleaseSuccess implements LoadingAction {
  readonly type = actions.PUBLISH_RELEASE_SUCCESS;
  readonly isLoading = false;

  constructor(
    public artistId: string,
    public releaseId: string,
    public allArtists: SimpleArtist[]
  ) {}
}

export class PublishReleaseError implements ErrorAction {
  readonly type = actions.PUBLISH_RELEASE_ERROR;
  readonly isError = true;

  constructor(
    public code: string,
    public errors?: string,
    public original?: PublishRelease
  ) {}
}
export class ValidateReleaseArtists implements LoadingAction {
  readonly type = actions.VALIDATE_RELEASE_ARTISTS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public artistId: string, public releaseId: string) {}
}

export class ValidateReleaseArtistsSuccess implements LoadingAction {
  readonly type = actions.VALIDATE_RELEASE_ARTISTS_SUCCESS;
  readonly isLoading = false;

  constructor(public artists: SimpleArtist[]) {}
}

export class ValidateReleaseArtistsError implements ErrorAction {
  readonly type = actions.VALIDATE_RELEASE_ARTISTS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ConfirmTakedownRelease implements Action {
  readonly type = actions.CONFIRM_TAKEDOWN_RELEASE;

  constructor(
    public artistId: string,
    public releaseId: string,
    public title: string,
    public isDelete: boolean
  ) {}
}

export class ConfirmCancelReleaseChanges implements Action {
  readonly type = actions.CONFIRM_CANCEL_RELEASE_CHANGES;

  constructor(public releaseId: string, public artistId: string) {}
}

export class TakedownRelease implements LoadingAction {
  readonly type = actions.TAKEDOWN_RELEASE;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public artistId: string,
    public releaseId: string,
    public title: string,
    public takedownBody?: any
  ) {}
}

export class TakedownReleaseSuccess implements LoadingAction {
  readonly type = actions.TAKEDOWN_RELEASE_SUCCESS;
  readonly isLoading = false;

  constructor(public artistId: string, public releaseId: string) {}
}

export class TakedownReleaseError implements ErrorAction {
  readonly type = actions.TAKEDOWN_RELEASE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}
export class CancelRelease implements LoadingAction {
  readonly type = actions.CANCEL_RELEASE;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public artistId: string, public releaseId: string) {}
}

export class CancelReleaseSuccess implements LoadingAction {
  readonly type = actions.CANCEL_RELEASE_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = false;

  constructor(public artistId: string, public releaseId: string) {}
}

export class CancelReleaseError implements ErrorAction {
  readonly type = actions.CANCEL_RELEASE_ERROR;
  readonly isError = true;
  readonly mainLoader = false;

  constructor(public code: string) {}
}

export class CancelPendingTakedown implements LoadingAction {
  readonly type = actions.CANCEL_PENDING_TAKEDOWN;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public artistId: string, public releaseId: string) {}
}

export class CancelPendingTakedownSuccess implements LoadingAction {
  readonly type = actions.CANCEL_PENDING_TAKEDOWN_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = false;

  constructor(
    public artistId: string,
    public releaseId: string,
    public status: ReleaseStatus
  ) {}
}

export class CancelPendingTakedownError implements ErrorAction {
  readonly type = actions.CANCEL_PENDING_TAKEDOWN_ERROR;
  readonly isError = true;
  readonly mainLoader = false;

  constructor(public code: string) {}
}

export class UpdatedTakedownRelease implements LoadingAction {
  readonly type = actions.UPDATED_TAKEDOWN_RELEASE;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public artistId: string,
    public releaseId: string,
    public takedownStores: ReleaseStore[]
  ) {}
}

export class UpdatedTakedownReleaseSuccess implements LoadingAction {
  readonly type = actions.UPDATED_TAKEDOWN_RELEASE_SUCCESS;
  readonly isLoading = false;

  constructor(
    public artistId: string,
    public releaseId: string,
    public takedownStores: ReleaseStore[]
  ) {}
}

export class UpdatedTakedownReleaseError implements ErrorAction {
  readonly type = actions.UPDATED_TAKEDOWN_RELEASE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}
export class UpdateRelease implements LoadingAction {
  readonly type = actions.UPDATE_RELEASE;
  readonly isLoading = true;

  constructor(public release: Partial<SimpleRelease>) {}
}

export class UpdateReleaseSuccess implements LoadingAction {
  readonly type = actions.UPDATE_RELEASE_SUCCESS;
  readonly isLoading = false;

  constructor(public release: Partial<SimpleRelease>) {}
}

export class UpdateReleaseError implements ErrorAction {
  readonly type = actions.UPDATE_RELEASE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class LoadRelease implements LoadingAction {
  readonly type = actions.LOAD_RELEASE;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public artistId: string,
    public releaseId: string,
    public fetchTracks?: boolean
  ) {}
}

export class LoadReleaseSuccess implements LoadingAction {
  readonly type = actions.LOAD_RELEASE_SUCCESS;
  readonly isLoading = false;

  constructor(public release: Partial<Release>, public fetchTracks?: boolean) {}
}

export class LoadReleaseError implements ErrorAction {
  readonly type = actions.LOAD_RELEASE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListReleasesSummary implements LoadingAction {
  readonly type = actions.LIST_RELEASES_SUMMARY;
  readonly isLoading = true;
}

export class ListReleasesSummarySuccess implements LoadingAction {
  readonly type = actions.LIST_RELEASES_SUMMARY_SUCCESS;
  readonly isLoading = false;

  constructor(public summary: ReleaseListSummary) {}
}

export class ListReleasesSummaryError implements ErrorAction {
  readonly type = actions.LIST_RELEASES_SUMMARY_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListReleases implements LoadingAction {
  readonly type = actions.LIST_RELEASES;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public status: ReleaseListKey, public includeTracks?: boolean) {}
}

export class ListReleasesSuccess implements LoadingAction {
  readonly type = actions.LIST_RELEASES_SUCCESS;
  readonly isLoading = false;

  constructor(
    public releases: SimpleRelease[],
    public status: ReleaseListKey,
    public includeTracks?: boolean
  ) {}
}

export class ListReleasesError implements ErrorAction {
  readonly type = actions.LIST_RELEASES_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListReleasesArtist implements LoadingAction {
  readonly type = actions.LIST_RELEASES_ARTIST;
  readonly isLoading = true;

  constructor(public artistId: string) {}
}

export class ListReleasesArtistSuccess implements LoadingAction {
  readonly type = actions.LIST_RELEASES_ARTIST_SUCCESS;
  readonly isLoading = false;

  constructor(public releases: SimpleRelease[], public artistId: string) {}
}

export class ListReleasesArtistError implements ErrorAction {
  readonly type = actions.LIST_RELEASES_ARTIST_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListReleasesDeactivatedArtist implements LoadingAction {
  readonly type = actions.LIST_RELEASES_DEACTIVATED_ARTIST;
  readonly isLoading = true;

  constructor(public artistId: string) {}
}

export class ListReleasesDeactivatedArtistSuccess implements LoadingAction {
  readonly type = actions.LIST_RELEASES_DEACTIVATED_ARTIST_SUCCESS;
  readonly isLoading = false;

  constructor(public releases: SimpleRelease[], public artistId: string) {}
}

export class ListReleasesDeactivatedArtistError implements ErrorAction {
  readonly type = actions.LIST_RELEASES_DEACTIVATED_ARTIST_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}
export class ListMultipleArtistsReleases implements LoadingAction {
  readonly type = actions.LIST_MULTIPLE_ARTIST_RELEASES;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public ids: string[]) {}
}

export class ListMultipleArtistsReleasesSuccess implements LoadingAction {
  readonly type = actions.LIST_MULTIPLE_ARTIST_RELEASES_SUCCESS;
  readonly isLoading = false;

  constructor(public ids: string[], public releases: SimpleRelease[]) {}
}

export class ListMultipleArtistsReleasesError implements ErrorAction {
  readonly type = actions.LIST_MULTIPLE_ARTIST_RELEASES_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}
export class ListFeaturing implements LoadingAction {
  readonly type = actions.LIST_FEATURING;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public status: ReleaseListKey, public includeTracks?: boolean) {}
}

export class ListFeaturingSuccess implements LoadingAction {
  readonly type = actions.LIST_FEATURING_SUCCESS;
  readonly isLoading = false;

  constructor(
    public releases: SimpleRelease[],
    public status: ReleaseListKey,
    public includeTracks?: boolean
  ) {}
}

export class ListFeaturingError implements ErrorAction {
  readonly type = actions.LIST_FEATURING_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ChangeActiveList implements Action {
  readonly type = actions.CHANGE_ACTIVE_LIST;

  constructor(public isSummary: boolean, public section: ReleaseListKey) {}
}

export class ResetReleaseStore implements Action {
  readonly type = actions.RESET_RELEASE_STORE;
}

export class ShareRelease implements Action {
  readonly type = actions.SHARE_RELEASE;

  constructor(
    public releaseId: string,
    public releaseTitle: string,
    public network: string
  ) {}
}

export class UnlockRelease implements Action {
  readonly type = actions.UNLOCK_RELEASE;
}

export class UpdateReleaseStoreError implements Action {
  readonly type = actions.UPDATE_RELEASE_STORE_ERROR;

  constructor(
    public error: string,
    public field: string,
    public value?: string,
    public releaseId?: string
  ) {}
}

export class AddArtistToRelease implements Action {
  readonly type = actions.ADD_ARTIST_TO_RELEASE;

  constructor(
    public name: string,
    public externalArtist?: ArtistSearchResult
  ) {}
}

export type ReleaseActions =
  | EditRelease
  | CleanRelease
  | StartRelease
  | UpdateField<keyof SimpleRelease>
  | AddArtistToRelease
  | LoadRelease
  | LoadReleaseSuccess
  | LoadReleaseError
  | ListReleases
  | ListReleasesSuccess
  | ListReleasesError
  | ListReleasesArtist
  | ListReleasesArtistSuccess
  | ListReleasesArtistError
  | ListReleasesDeactivatedArtist
  | ListReleasesDeactivatedArtistSuccess
  | ListReleasesDeactivatedArtistError
  | ListMultipleArtistsReleases
  | ListMultipleArtistsReleasesSuccess
  | ListMultipleArtistsReleasesError
  | ListFeaturing
  | ListFeaturingSuccess
  | ListFeaturingError
  | ChangeActiveList
  | ListReleasesSummary
  | ListReleasesSummarySuccess
  | ListReleasesSummaryError
  | CreateRelease
  | CreateReleaseSuccess
  | CreateReleaseError
  | UpdateRelease
  | UpdateReleaseSuccess
  | UpdateReleaseError
  | PublishRelease
  | PublishReleaseSuccess
  | PublishReleaseError
  | ValidateReleaseArtists
  | ValidateReleaseArtistsSuccess
  | ValidateReleaseArtistsError
  | ConfirmTakedownRelease
  | TakedownRelease
  | TakedownReleaseSuccess
  | TakedownReleaseError
  | CancelRelease
  | CancelReleaseSuccess
  | CancelReleaseError
  | CancelPendingTakedown
  | CancelPendingTakedownSuccess
  | CancelPendingTakedownError
  | UpdatedTakedownRelease
  | UpdatedTakedownReleaseSuccess
  | UpdatedTakedownReleaseError
  | ResetReleaseStore
  | ShareRelease
  | UnlockRelease
  | UpdateReleaseStoreError;
